let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Wt2t")).then(() => parcelRequire('1JnF6'));